const STORAGE_DOMAIN_OPTIONS = new Map([
  ["tb_web_prefs_v1", { includePreferences: true }],
  ["tb_public_web_brief_profile_v1", { includePreferences: true }],
  ["tb_public_web_home_carousel_v1", { includePreferences: true }],
  ["tb_web_theme_mode_v2", { includeTheme: true }],
  ["tb_web_theme_palette_v2", { includeTheme: true }],
  ["tb_web_theme_auto_transition_v1", { includeTheme: true }],
  ["tb_web_theme_high_contrast_v1", { includeTheme: true }],
  ["tb_public_web_tasks_v1", { includeTasks: true }],
  ["tb_public_web_saved_articles_v1", { includeSavedArticles: true }],
  ["tb_public_web_market_watchlist_v1", { includeWatchlist: true, includePreferences: true }],
  ["tb_public_web_sync_deletions_v1", { includeTasks: true, includeSavedArticles: true }],
]);

/**
 * Maps only sync-authoritative account rows. Bootstrap journals, caches,
 * audio history, and anonymous/other-account rows must never recursively
 * schedule an account-data push.
 */
export function accountScopedSyncOptionsForStorageKey(key, accountScope) {
  const normalizedScope = String(accountScope || "").trim();
  if (typeof key !== "string" || !normalizedScope.startsWith("account_")) return null;
  const suffix = `::${normalizedScope}`;
  if (!key.endsWith(suffix)) return null;
  const baseKey = key.slice(0, -suffix.length);
  const options = STORAGE_DOMAIN_OPTIONS.get(baseKey);
  return options ? { ...options } : null;
}
